<footer class="rpt-footer noprint">
  <div class="rpt-wrap rpt-footer__inner">
    <div class="rpt-footer__meta">Report generated {{today | date:'d MMM yyyy'}} · Adventum Capital</div>
    <div style="display:flex;gap:8px;flex-wrap:wrap;">
      <button class="rpt-btn rpt-btn--primary" (click)="recalculate.emit()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
        Recalculate
      </button>
      <button class="rpt-btn rpt-btn--accent" (click)="download.emit()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        Download PDF
      </button>
    </div>
  </div>
</footer>
